import { Lang } from "../../types";
export const getLangPath = (lang = Lang.EN) => (lang !== Lang.EN ? lang : null);
